import { useState } from "react";
import { Link } from "react-router-dom";
import {
  useChangePasswordWithOtpMutation,
  useForgotPasswordMutation,
} from "../store/api";
import { Loader } from "../components/icons";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();
  const [changePassword, { isLoading: isUpdating }] =
    useChangePasswordWithOtpMutation();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    try {
      const res = await forgotPassword(email).unwrap();
      localStorage.setItem("resetEmail", email);
      setMessage(res?.message || "OTP sent to your email");
      setShowModal(true);
    } catch (err) {
      setError(err?.data?.message || "Something went wrong");
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();

    const email = localStorage.getItem("resetEmail");

    try {
      await changePassword({
        email,
        otp,
        newPassword,
      }).unwrap();

      setMessage("Password updated successfully");
      setShowModal(false);
    } catch (err) {
      setError(err?.data?.message || "Failed to reset password");
    }
  };
  return (
    <div className="h-screen flex items-center justify-center bg-gray-50 px-6">
      <div className="w-full max-w-md bg-white p-8 rounded-2xl shadow">
        <h1 className="text-2xl font-bold text-center mb-2">Forgot Password</h1>

        <p className="text-sm text-gray-500 text-center mb-6">
          Enter your email to receive an OTP for password reset
        </p>

        {message && (
          <div className="mb-4 text-green-600 text-sm text-center">
            {message}
          </div>
        )}
        {error && (
          <div className="mb-4 p-3 bg-red-100 text-red-700 rounded">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <label className="block text-sm mb-1">Email</label>

          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-1 focus:ring-purple-600"
            required
          />

          <button
            type="submit"
            className="w-full mt-5 bg-[#6D4E8A] text-white py-3 rounded-full hover:opacity-90 transition flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {isLoading ? (
              <>
                <Loader /> Sending...
              </>
            ) : (
              "Send OTP"
            )}
          </button>
        </form>

        <div className="text-center mt-4">
          <Link
            to="/account/login"
            className="text-sm text-purple-700 underline"
          >
            Back to Login
          </Link>
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-md p-6 rounded-xl shadow-lg">
            <h2 className="text-xl font-bold mb-4">Reset Password</h2>

            <form onSubmit={handleResetPassword}>
              <input
                type="text"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                className="w-full mb-3 p-3 border rounded"
                required
              />

              <input
                type="password"
                placeholder="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="w-full mb-3 p-3 border rounded"
                required
              />

              <div className="flex gap-3">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="w-1/2 bg-gray-200 py-2 rounded"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  disabled={isUpdating}
                  className="w-1/2 bg-[#6D4E8A] text-white py-2 rounded"
                >
                  {isUpdating ? "Updating..." : "Reset Password"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
